import React, { useCallback } from 'react'
import Button from '../../../Button'
import cn from 'classnames'
import { groupBy, isEmpty, keys, sortBy } from 'lodash'

import './index.scss'

const ButtonsList = ({ data, submit, actionBtn, legend }) => {
  const legendColors = useCallback(() => {
    if (!legend || isEmpty(data)) return []

    const colors = data.reduce((acc, inc) => [...acc, { ...inc.color }], [])

    const grouped = groupBy(colors, 'label')
    return sortBy(
      keys(grouped).map((key) => ({
        value: grouped[key][0].value,
        label: grouped[key][0].label
      })),
      'label'
    )
  }, [data, legend])

  return (
    <div className='KPI-buttons-list-wrapper'>
      <div className='KPI-buttons-list'>
        {data.map(({ title, onClick, selected, color = {} }, idx) => (
          <div key={`kpi-factory-btn-${idx}`} className='btn-wrapper'>
            <Button
              kind={selected ? 'primary' : 'tertiary'}
              onClick={() => onClick(title)}
              className={cn('btn', {
                [color.value ?? '']: color.value
              })}
            >
              {title}
            </Button>
          </div>
        ))}
      </div>

      {actionBtn && (
        <div className='action-wrapper'>
          <Button onClick={submit.onClick} className='btn'>
            {submit.title}
          </Button>
        </div>
      )}
      {legend && (
        <div className='btns-list-legend'>
          {legendColors().map((color, idx) => (
            <span
              key={idx}
              className={cn('legend', { [color.value]: color.value })}
            >
              {color.label}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default ButtonsList
